import { render } from "./ChangeSubModal.vue?vue&type=template&id=73aff6ea&scoped=true"
import script from "./ChangeSubModal.vue?vue&type=script&lang=js"
export * from "./ChangeSubModal.vue?vue&type=script&lang=js"

import "./ChangeSubModal.vue?vue&type=style&index=0&id=73aff6ea&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73aff6ea"]])

export default __exports__